import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getTypeValidationVasActionAsync } from '../redux/actions/TypeValidationVasAction'

export const useTypeValidationVas = () => {
  const { typeValidationVasState } = useSelector(
    (state: RootState) => state.typeValidationVas
  )

  const dispatch = useDispatch()

  const getTypeValidationVas = () => {
    dispatch(getTypeValidationVasActionAsync())
  }

  return { typeValidationVasState, getTypeValidationVas }
}
